import Model from '@app/Model'

export class PartCategory extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			isPart: false,
			ebayUkId: null,
			ebayUsId: null,
			ebayDeId: null
		}
	}
}
export function createPartCategory (data) {
	return Object.freeze(new PartCategory(data))
}
